var vitalsStarted = false;
var vitalsPromise = null;

function navigationType() {
  if (!window.performance || typeof window.performance.getEntriesByType !== 'function') {
    return 'unknown';
  }

  var navigation = window.performance.getEntriesByType('navigation')[0];
  return navigation && navigation.type ? navigation.type : 'unknown';
}

function roundedMetricValue(metric) {
  return Number(metric.value.toFixed(metric.name === 'CLS' ? 3 : 0));
}

function analyticsValue(metric, value) {
  return metric.name === 'CLS' ? Math.round(value * 1000) : value;
}

function startWebVitals(vitals) {
  if (vitalsStarted || !window.PerformanceObserver) {
    return;
  }

  vitalsStarted = true;

  // Core Web Vitals describe the hard document lifecycle. Keep this context
  // immutable when Turbolinks replaces the body during a soft navigation.
  var initialPageTemplate = document.body && document.body.dataset.pageTemplate || 'unknown';
  var initialNavigationType = navigationType();

  function report(metric) {
    if (typeof window.gtag !== 'function') {
      return;
    }

    var metricValue = roundedMetricValue(metric);
    var metricDelta = Number(metric.delta.toFixed(metric.name === 'CLS' ? 3 : 0));

    window.gtag('event', 'web_vital_' + metric.name.toLowerCase(), {
      value: analyticsValue(metric, metricValue),
      metric_name: metric.name,
      metric_value: metricValue,
      metric_delta: metricDelta,
      metric_rating: metric.rating,
      metric_id: metric.id,
      initial_page_template: initialPageTemplate,
      page_template: initialPageTemplate,
      navigation_mode: 'hard',
      navigation_type: metric.navigationType || initialNavigationType,
      non_interaction: true
    });
  }

  vitals.onCLS(report);
  vitals.onINP(report);
  vitals.onLCP(report);
}

function loadWebVitals() {
  if (vitalsStarted || vitalsPromise || !window.PerformanceObserver) {
    return;
  }

  vitalsPromise = import(
    /* webpackChunkName: "web-vitals" */
    'web-vitals'
  ).then(function (vitals) {
    startWebVitals(vitals);
  }).catch(function () {
    vitalsPromise = null;
  });
}

document.addEventListener('turbolinks:load', loadWebVitals);
